import React from 'react';

const AgeGate = ({ onConfirm, onDeny, isMobile }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px'
    }}>
      <div style={{
        background: '#FFFFFF',
        border: '4px solid #333333',
        boxShadow: '8px 8px 0px rgba(0, 0, 0, 0.3)',
        maxWidth: '500px',
        width: '100%',
        padding: isMobile ? '24px' : '40px',
        textAlign: 'center'
      }}>
        <h2 style={{
          margin: '0 0 24px 0',
          fontSize: isMobile ? '1.5rem' : '2rem',
          fontWeight: '900',
          color: '#333333',
          textTransform: 'uppercase',
          letterSpacing: '0.05em'
        }}>
          Age Verification
        </h2>

        <p style={{
          margin: '0 0 32px 0',
          fontSize: isMobile ? '1rem' : '1.2rem',
          fontWeight: '600',
          color: '#555555',
          lineHeight: '1.6'
        }}>
          Are you 16 years of age or older?
        </p>

        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: '16px',
          justifyContent: 'center'
        }}>
          <button
            onClick={onConfirm}
            style={{
              padding: '16px 32px',
              fontSize: isMobile ? '1rem' : '1.1rem',
              fontWeight: '900',
              color: '#FFFFFF',
              background: '#28a745',
              border: '3px solid #333333',
              boxShadow: '4px 4px 0px #333333',
              cursor: 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              transition: 'all 0.2s ease',
              minWidth: isMobile ? '100%' : '140px'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translate(2px, 2px)';
              e.target.style.boxShadow = '2px 2px 0px #333333';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translate(0, 0)';
              e.target.style.boxShadow = '4px 4px 0px #333333';
            }}
          >
            Yes, I'm 16 or Older
          </button>

          <button
            onClick={onDeny}
            style={{
              padding: '16px 32px',
              fontSize: isMobile ? '1rem' : '1.1rem',
              fontWeight: '900',
              color: '#FFFFFF',
              background: '#dc3545',
              border: '3px solid #333333',
              boxShadow: '4px 4px 0px #333333',
              cursor: 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              transition: 'all 0.2s ease',
              minWidth: isMobile ? '100%' : '140px'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translate(2px, 2px)';
              e.target.style.boxShadow = '2px 2px 0px #333333';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translate(0, 0)';
              e.target.style.boxShadow = '4px 4px 0px #333333';
            }}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeGate;
